import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { PhotoUploadCallback } from "controls";

@Injectable({ providedIn: 'root' })
export class PhotoUploadCallbackImpl extends PhotoUploadCallback {
    confirmPhotoDeletion(): Observable<boolean> {
        return of(true);
    }
}
